/**
 * The Corp Events surface's static skeleton values. Shared by the cards
 * below, which render the design's layout as em-dashes until the data lands.
 */
import type { CSSProperties } from 'react';

export const EM_DASH = '—';
export const MONTH_SLOTS = ['m1', 'm2', 'm3'] as const;
export const KANBAN_STATUSES = [
  'Inquired',
  'Responded',
  'Invoice sent',
  'Deposit paid',
  'Headcount submitted',
] as const;
export const ROWS = ['a', 'b', 'c'] as const;

export const heading: CSSProperties = { fontSize: 13, letterSpacing: '0.04em', margin: 0 };
export const subtle = 'var(--nb-subtle)';

export const LEGEND: ReadonlyArray<{ label: string; tone: string }> = [
  { label: 'Deposit paid', tone: 'var(--nb-primary)' },
  { label: 'Invoice sent', tone: 'var(--nb-warn)' },
  { label: 'Responded', tone: 'var(--nb-info)' },
  { label: 'Inquired', tone: 'var(--nb-subtle)' },
];
